export default ({ request }) => ({
  resFabricPurchaseListApi(data = {}) {
    return request({
      url: '/digitalCenter/res/fabric/purchase/list',
      method: 'post',
      data,
    })
  },
  resFabricPurchaseProcureListApi(data = {}) {
    return request({
      url: '/digitalCenter/res/fabric/purchase/procure/list',
      method: 'post',
      data,
    })
  },
  resFabricPurchaseGenerateApi(data = {}) {
    return request({
      url: '/digitalCenter/res/fabric/purchase/generate',
      method: 'post',
      data,
    })
  },
  resFabricPurchaseProcureDetailApi(data = {}) {
    return request({
      url: '/digitalCenter/res/fabric/purchase/procure/detail',
      method: 'post',
      data,
    })
  },
  resFabricPurchaseDetailListApi(data = {}) {
    return request({
      url: '/digitalCenter/res/fabric/purchase/detailList',
      method: 'post',
      data,
    })
  },
  resFabricPurchaseProcureSaveApi(data = {}) {
    return request({
      url: '/digitalCenter/res/fabric/purchase/procure/save',
      method: 'post',
      data,
    })
  },

  resFabricPurchaseConfirmApi(data = {}) {
    return request({
      url: '/digitalCenter/res/fabric/purchase/confirm',
      method: 'post',
      data,
    })
  },
  resFabricPurchaseDelApi(data = {}) {
    return request({
      url: '/digitalCenter/res/fabric/purchase/del',
      method: 'post',
      data,
    })
  },
  resFabricPurchaseReceiptConfirmationApi(data = {}) {
    return request({
      url: '/digitalCenter/res/fabric/purchase/receipt/confirmation',
      method: 'post',
      data,
    })
  },
  resFabricInfoImg2ColorApi(data = {}) {
    return request({
      url: '/digitalCenter/res/fabric/info/img/color',
      method: 'post',
      data,
    })
  },
  resFabricVoiceListApi(data = {}) {
    return request({
      url: '/digitalCenter/res/fabric/voice/list',
      method: 'post',
      data,
    })
  },
  resFabricVoiceDelApi(data = {}) {
    return request({
      url: '/digitalCenter/res/fabric/voice/del',
      method: 'post',
      data,
    })
  },
})
